import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { useSettings } from "../../hooks/useSettings";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";

const PrivacyPolicy = ({ location }) => {
    const { pathname } = location;
    const { siteName } = useSettings();

    return (
        <Fragment>
            <MetaTags>
                <title>Privacy Policy | {siteName}</title>
                <meta
                    name="description"
                    content="Terms and Condition page laura veils"
                />
            </MetaTags>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>Home</BreadcrumbsItem>
            <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
                Privacy Policy
            </BreadcrumbsItem>
            <LayoutOne headerTop="visible">
                {/* breadcrumb */}
                <Breadcrumb />
                <div className="blog-area pt-10 pb-100">
                    <div className="container">
                        <div className="row flex-row-reverse">
                            <div className="col-lg-12">
                                <div className="blog-details-wrapper ml-20">
                                    <div className="blog-details-top">
                                        <div className="w-100 text-center pt-10"><h2>Privacy Policy</h2></div>
                                        <div className="blog-details-content">
                                            <h3 style={{ fontWeight: '600' }}>Collecting and Using Your Personal Data</h3>
                                            <h3 className="pt-20">Types of Data Collected</h3>
                                            <h3 className="pt-20">Personal Data</h3>
                                            <p>
                                                While using our services, we may ask you to provide certain personally identifiable information that can be used to contact or identify you. This includes but is not limited to:
                                            </p>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Email address</li>
                                                <li className="mb-2">First and last name</li>
                                                <li className="mb-2">Phone number</li>
                                                <li className="mb-2">Address, State, Province, ZIP/Postal Code, City</li>
                                            </ul>
                                            <h3 className="pt-30">Usage Data</h3>
                                            <p>
                                                We automatically collect Usage Data when you use our services. Usage Data may include information such as:
                                            </p>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Your device’s IP address</li>
                                                <li className="mb-2">Browser type and version</li>
                                                <li className="mb-2">Pages you visit on our service</li>
                                                <li className="mb-2">Date and time of your visit</li>
                                                <li className="mb-2">Time spent on each page</li>
                                                <li className="mb-2">Unique device identifiers</li>
                                                <li className="mb-2">Diagnostic and performance data</li>
                                            </ul>
                                            <p >
                                                When you access our services through a mobile device, we may collect additional information, such as your mobile device type, operating system, and browser type.
                                            </p>
                                            <h3 className="pt-30">Tracking Technologies and Cookies</h3>
                                            <p >
                                                We use cookies and similar tracking technologies to enhance your experience and analyze our services
                                            </p>
                                            <h5 className="pt-30">Types of Cookies We Use:</h5>
                                            <ul className="ml-5" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Essential Cookies: Enable core functionalities like authentication and security.</li>
                                                <li className="mb-2">Acceptance Cookies: Record your acknowledgment of our use of cookies.</li>
                                                <li className="mb-2">Functionality Cookies: Remember your preferences, such as language and login details.</li>
                                            </ul>
                                            <p >
                                                You can manage cookies through your browser settings. Note that disabling cookies may limit your ability to use certain features.
                                            </p>
                                            <h3 className="pt-30">Types of Cookies We Use:</h3>
                                            <p>We use your personal data for the following purposes:</p>
                                            <ul className="ml-5 pt-10" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">To Provide Our Service: Maintain, improve, and monitor our services.</li>
                                                <li className="mb-2">Account Management: Facilitate your registration and provide access to user-specific features.</li>
                                                <li className="mb-2">Contract Fulfillment: Process and manage purchase contracts for goods or services</li>
                                                <li className="mb-2">Customer Support: Respond to your inquiries and requests.</li>
                                                <li className="mb-2">Marketing Communications: Share updates, special offers, and information about similar products and services, unless you opt out.</li>
                                                <li className="mb-2">Business Operations: Evaluate potential mergers, sales, or other business arrangements.</li>
                                                <li className="mb-2">Legal Compliance: Comply with laws, regulations, and legal obligations.</li>
                                            </ul>
                                            <h3 className="pt-30">Sharing Your Personal Data</h3>
                                            <p>We may share your personal data in the following scenarios</p>
                                            <ul className="ml-5 pt-10" style={{ listStyleType: 'square' }}>
                                                <li className="mb-2">Service Providers: To facilitate our services or provide analytics.</li>
                                                <li className="mb-2">Business Transfers: In case of mergers, acquisitions, or asset sales.</li>
                                                <li className="mb-2">Affiliates: With our affiliates, under the same Privacy Policy terms.</li>
                                                <li className="mb-2">With Consent: For purposes explicitly approved by you.</li>
                                            </ul>
                                            <h3 className="pt-30">Retention of Your Data</h3>
                                            <p>Your data will be retained only as long as necessary for the purposes stated in this policy.</p>
                                            <p className="pt-30">Usage Data may be retained longer for analytical purposes or to improve security.</p>
                                            <h3 className="pt-30">Transfer of Your Personal Data</h3>
                                            <p>Your data may be processed in locations outside your jurisdiction. We ensure adequate data protection measures are in place before transferring any personal data.
                                            </p>
                                            <h3 className="pt-30">Security of Your Personal Data</h3>
                                            <p>We use commercially reasonable measures to protect your personal data but cannot guarantee 100% security due to the nature of online data transmission</p>
                                            <h3 className="pt-30">Children’s Privacy</h3>
                                            <p>Our services are not intended for children under 13 years old. If you become aware that a child has provided us with personal data without parental consent, please contact us immediately
                                            </p>
                                            <h3 className="pt-30">Links to Third-Party Websites</h3>
                                            <p>We are not responsible for the privacy practices of other websites. Please review their privacy policies before providing any information.
                                            </p>
                                            <h3 className="pt-30">Changes to This Privacy Policy</h3>
                                            <p>We may update this policy periodically. Changes will be notified via email or a prominent notice on our website, along with an updated “Last Updated” date.

                                            </p>
                                            <h3 className="pt-30">Contact Us</h3>
                                            <p>For questions or concerns about this Privacy Policy, contact us at:
                                            </p>
                                            <ul>
                                                <li>Email: info@lauraveils.com</li>
                                            </ul>
                                            <p>Your privacy matters to us, and we are committed to protecting your personal data.
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </LayoutOne>
        </Fragment>
    );
};

PrivacyPolicy.propTypes = {
    location: PropTypes.object
};

export default PrivacyPolicy;
